import {Component, EventEmitter, Input, Output} from '@angular/core';


enum TagEnum {
  'none',
  'success',
  'warning',
  'danger',
  'info',
}

const typeArray = ['', 'success', 'warning', 'danger', 'info'];
const iconArray = ['', 'play-success', 'warning', 'danger', 'clock-light-blue']

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})


export class BannerComponent {
  @Input() customIcon: string;
  @Input() label: string;
  @Input() withAction = false;
  @Input() type: TagEnum  = 1;
  @Input() boldText  = "";
  @Input() textDirection: 'start' | 'center' | 'end'  = "start"; // start - center - end
  @Input() labelAction  = "Action";
  @Output() clickAction = new EventEmitter<any>()

  constructor() {
  }

  get iconName(): string {
    return this.customIcon ? this.customIcon : this.type !== TagEnum.none ? iconArray[this.type] : ''
  }

  handleClickAction() {
    this.clickAction.emit()
  }

  protected readonly typeArray = typeArray;
}
